export default __webpack_public_path__ + "static/media/twitter-1446411363333595136.9db53581.jpg";